export class DisplayChart {

  static hover(idx: number, container: HTMLElement, color: string) {
    const paths = container.getElementsByTagName("path");
    const items = container.getElementsByClassName("key-item");
    for (let j = 0; j < paths.length; j++) {
      const path = paths[j];
      if (j == idx) {
        path.style.fill = color;
      } else {
        path.style.fill = "#e2e2e2";
      }
    }
    for (let j = 0; j < items.length; j++) {
      const item = items[j] as HTMLElement;
      const block = item.querySelector("div.key-color-block") as HTMLElement;
      if (j == idx) {
        if (block) {
          block.style.backgroundColor = color;
        }
        item.classList.remove("hover-off");
        item.classList.add("hover-on");
      } else {
        if (block) {
          block.style.backgroundColor = "#e2e2e2";
        }
        item.classList.remove("hover-on");
        item.classList.add("hover-off");
      }
    }
  }

  static clearHover(container: HTMLElement) {
    const paths = container.getElementsByTagName("path");
    const items = container.getElementsByClassName("key-item");
    for (let j = 0; j < paths.length; j++) {
      const path = paths[j];
      const color = path.getAttribute("data-color");
      if (color) {
        path.style.fill = color;
      }
    }
    for (let j = 0; j < items.length; j++) {
      const item = items[j] as HTMLElement;
      const block = item.querySelector("div.key-color-block") as HTMLElement;
      item.classList.remove("hover-off");
      item.classList.remove("hover-on");
      if (block) {
        const c = block.getAttribute("data-color");
        if (c) {
          block.style.backgroundColor = c;
        }
      }
    }
  }
}